import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InteraccionDto } from '../../../dto/justino/interaccion.dto';

@Component({
  selector: 'app-interaccion',
  templateUrl: './interaccion.component.html',
  styleUrl: './interaccion.component.scss',
})
export class InteraccionComponent implements OnInit {
  isExpanded: boolean = false;

  @Input() nivel: number = 0;
  @Input() interaccion!: InteraccionDto;
  @Input() isReadOnly: boolean = false;

  @Output() seleccionado = new EventEmitter<InteraccionDto>();
  @Output() actualizar = new EventEmitter<InteraccionDto>();
  @Output() eliminar = new EventEmitter<InteraccionDto>();
  @Output() agregar = new EventEmitter<InteraccionDto>();

  ngOnInit(): void {
    if (this.interaccion) {
      this.isExpanded = this.interaccion.isExpanded;
    }
  }

  onAgregar() {
    this.agregar.emit(this.interaccion);
  }

  onActualizar() {
    this.actualizar.emit(this.interaccion);
  }

  onEliminar() {
    this.eliminar.emit(this.interaccion);
  }

  onSeleccionar() {
    this.seleccionado.emit(this.interaccion);
  }

  toggleCollapse() {
    this.isExpanded = !this.isExpanded;
  }
}
